import { runtimeConfig } from "./runtimeConfig";

export interface AgentConfig {
  /** Base URL of the Tower.Agent service, no trailing slash. */
  baseUrl: string;
  /** Whether the agent drawer is shown at all (feature flag, epic #481). */
  enabled: boolean;
}

function trimTrailingSlash(value: string): string {
  // A plain loop: the equivalent /\/+$/ regex backtracks super-linearly.
  let trimmed = value;
  while (trimmed.endsWith("/")) {
    trimmed = trimmed.slice(0, -1);
  }
  return trimmed;
}

const rawBaseUrl = runtimeConfig.TOWER_AGENT_BASE_URL;

export const agentConfig: AgentConfig = {
  baseUrl: trimTrailingSlash(rawBaseUrl),
  enabled: runtimeConfig.TOWER_AGENT_ENABLED === "true" && rawBaseUrl.length > 0,
};
